import { useQuery } from '@tanstack/react-query';
import { getEntitlements } from '../api/entitlements/getEntitlements';

export const useGetEntitlements = () => {
  const { isLoading, data, isError } = useQuery({
    queryKey: ['entitlements'],
    queryFn: getEntitlements,
  });

  return {
    initializing: isLoading || isError,
    entitlements: data,
  };
};
